export class ChartData {
    data: any;
	loading: boolean;

	constructor(init?: Partial<ChartData>) {
		Object.assign(this, init);
	}
}
